import {  APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
//import { InformationMapsComponent } from './directives/information/information-maps/information-maps.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideUserIdleConfig } from 'angular-user-idle';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { UsuarioResolve } from './usuario-resolve';
import { LoginResolve } from './resolves/login-resolve';
import { UsuariosResolve } from './resolves/usuario-resolve';
import { DatePipe } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { AuthInterceptorService } from './service/auth-interceptor.service';
import { GoogleMapsModule } from '@angular/google-maps';
import { BsModalService } from 'ngx-bootstrap/modal';
import { GoogleMapsService } from './service/GoogleMaps.service';
// export function initializeGoogleMaps(gMaps: GoogleMapsService) {
//   return () => gMaps.load((environment.CONFIGURATION as any).api_key_google);
// }
@NgModule({
  declarations: [
    AppComponent,
    //InformationMapsComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    RecaptchaV3Module,
    GoogleMapsModule,
  ],
  providers: [UsuarioResolve, LoginResolve, UsuariosResolve, DatePipe, CookieService,BsModalService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true },
    provideUserIdleConfig({ idle: environment.TIEMPO_SESION.TIEMPO, timeout: environment.TIEMPO_SESION.TIMEOUT, ping: environment.TIEMPO_SESION.PING }),
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: initializeGoogleMaps,
    //   deps: [GoogleMapsService],
    //   multi: true
    // },
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.RECAPCHA.SITEKEY }],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
